import { BehaviorSubject, Observable } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

export class StateService<T> {
	private state$: BehaviorSubject<T>;
	protected get state(): T {
		return this.state$.getValue();
	}

	public constructor(initialState: T) {
		this.state$ = new BehaviorSubject<T>(initialState);
	}

	protected select<K>(mapFn: (state: T) => K): Observable<K> {
		return this.state$.asObservable().pipe(
			map((state: T) => mapFn(state)),
			distinctUntilChanged()
		);
	}

	protected setState(newState: Partial<T>): void {
		this.state$.next({
			...this.state,
			...newState
		});
	}

	protected isStateLoaded(): boolean {
		return !!this.state;
	}

	protected resetStateToNull(): void {
		this.state$.next(null);
	}
}

export interface BaseState {
	isError: boolean;
	isSuccess: boolean; // means "is loaded"
}

export class StateServiceWithMeta<T extends BaseState> extends StateService<T> {
	public getState$(): Observable<T> {
		return this.select((state) => state);
	}

	public updateState(state: Partial<T>): void {
		this.setState({
			...state
		});
	}

	public isLoadedSuccessfully(): boolean {
		return this.state.isSuccess;
	}
}
